// extracted by mini-css-extract-plugin
module.exports = {"contents":"Loading_contents__2bFLN","loading-video":"Loading_loading-video__3ydSR","loading-text":"Loading_loading-text__11c8O"};